export const openInvoicesSampleData = {
  list: [
    {
      id: 3,
      currency: 'USD',
      status: 'PENDING',
      deleted: false,
      invoice_no: 'I0003',
      invoice_title: 'I0003',
      invoice_url: 'https://pdfobject.com/pdf/sample.pdf',
      balance_due_amount: 0,
      balance_due_amount_data: {
        value: 0,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 0,
            currency: 'USD',
            value_in_transformed_currency: 0,
            transformed_currency: 'USD',
          },
        ],
      },
      balance_due_amount_base_currency: 0,
      amount: 34869.24,
      amount_data: {
        value: 34869.24,
        currency: 'USD',
      },
      inv_amount_customer_currency: {
        value: 34869.24,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 34869.24,
            currency: 'USD',
            transformed_currency: 'USD',
          },
        ],
      },
      amount_base_currency: 34869.24,
      inv_balance_due_amount_customer_currency: {
        value: 0,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 0,
            currency: 'USD',
            transformed_currency: 'USD',
          },
        ],
      },
      promise_to_pay_amount: 0,
      promise_to_pay_amount_base_currency: 0,
      due_date: '2023-11-27',
      status_updated_date: '2023-11-27T00:00:00+0000',
      payment_status: 'PENDING',
      followup_status: 'DISPUTE_CLOSED',
      invoice_date: '2023-10-13',
      customer_id: 1,
      customer_name: 'Peace Inc',
      created_by: {
        id: 1,
        hash: 'W3lhn4FkF45Kxo',
        email: 'vignesh.iyappan@growfin.ai',
        first_name: 'vignesh.iyappan',
        last_name: 'Iyappan',
      },
      created_date: '2024-05-16T05:47:21+0000',
      closed_date: '2024-03-01',
      predicted_pay_date: '2022-04-05',
      billing_contacts: [],
      custom_fields: [
        {
          id: 1,
          display_name: 'Custom Field 1',
          value: 'Custom Value 1',
          name: 'custom_field_1',
          type: 'STRING',
        },
        {
          id: 2,
          display_name: 'Custom Field 2',
          value: 'Custom Value 2',
          name: 'custom_field_2',
          type: 'STRING',
        },
      ],
      draft_invoice: false,
    },
    {
      id: 10,
      currency: 'USD',
      status: 'PENDING',
      deleted: false,
      invoice_no: 'I0010',
      invoice_title: 'I0010',
      balance_due_amount: 43505.13,
      balance_due_amount_data: {
        value: 43505.13,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 43505.13,
            currency: 'USD',
            value_in_transformed_currency: 43505.13,
            transformed_currency: 'USD',
          },
        ],
      },
      balance_due_amount_base_currency: 43505.13,
      amount: 4305.13,
      amount_data: {
        value: 43505.13,
        currency: 'USD',
      },
      inv_amount_customer_currency: {
        value: 43505.13,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 43505.13,
            currency: 'USD',
            transformed_currency: 'USD',
          },
        ],
      },
      amount_base_currency: 43505.13,
      inv_balance_due_amount_customer_currency: {
        value: 43505.13,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 43505.13,
            currency: 'USD',
            transformed_currency: 'USD',
          },
        ],
      },
      promise_to_pay_amount: 0,
      promise_to_pay_amount_base_currency: 0,
      due_date: '2024-04-05',
      status_updated_date: '2024-04-05T00:00:00+0000',
      payment_status: 'PENDING',
      followup_status: 'CONTACT_MISSING',
      invoice_date: '2024-02-20',
      customer_id: 1,
      customer_name: 'Peace Inc',
      created_by: {
        id: 1,
        hash: 'W3lhn4FkF45Kxo',
        email: 'vignesh.iyappan@growfin.ai',
        first_name: 'vignesh.iyappan',
        last_name: 'Iyappan',
      },
      created_date: '2024-05-16T05:47:21+0000',
      predicted_pay_date: '2022-04-05',
      billing_contacts: [],
      custom_fields: [
        {
          id: 2,
          display_name: 'Custom Field 2',
          value: 'Custom Value 2',
          name: 'custom_field_2',
          type: 'STRING',
        },
      ],
      draft_invoice: false,
    },
    {
      id: 1,
      currency: 'USD',
      status: 'DISPUTE',
      deleted: false,
      invoice_no: 'I0001',
      invoice_title: 'I0001',
      balance_due_amount: 100,
      balance_due_amount_data: {
        value: 100,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 100,
            currency: 'USD',
            value_in_transformed_currency: 100,
            transformed_currency: 'USD',
          },
        ],
      },
      balance_due_amount_base_currency: 100,
      amount: 33349.41,
      amount_data: {
        value: 33349.41,
        currency: 'USD',
      },
      inv_amount_customer_currency: {
        value: 33349.41,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 33349.41,
            currency: 'USD',
            transformed_currency: 'USD',
          },
        ],
      },
      amount_base_currency: 33349.41,
      inv_balance_due_amount_customer_currency: {
        value: 100,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 100,
            currency: 'USD',
            transformed_currency: 'USD',
          },
        ],
      },
      promise_to_pay_amount: 100,
      promise_to_pay_amount_base_currency: 100,
      promise_to_pay_date: '2024-05-24',
      due_date: '2024-05-11',
      status_updated_date: '2024-06-11T14:52:38+0000',
      payment_status: 'PENDING',
      followup_status: 'DISPUTE_OPEN',
      invoice_date: '2024-03-27',
      customer_id: 1,
      customer_name: 'Peace Inc',
      created_by: {
        id: 1,
        hash: 'W3lhn4FkF45Kxo',
        email: 'vignesh.iyappan@growfin.ai',
        first_name: 'vignesh.iyappan',
        last_name: 'Iyappan',
      },
      created_date: '2024-05-16T05:47:21+0000',
      closed_date: '2024-03-27',
      last_activity_type: 'DISPUTE_OPEN',
      last_activity_date: '2024-06-11T14:52:38+0000',
      predicted_pay_date: '2022-04-05',
      billing_contacts: [],
      custom_fields: [],
      draft_invoice: false,
    },
    {
      id: 4,
      currency: 'USD',
      status: 'PENDING',
      deleted: false,
      invoice_no: 'I0004',
      invoice_title: 'I0004',
      balance_due_amount: 30500.97,
      balance_due_amount_data: {
        value: 30500.97,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 30500.97,
            currency: 'USD',
            value_in_transformed_currency: 30500.97,
            transformed_currency: 'USD',
          },
        ],
      },
      balance_due_amount_base_currency: 30500.97,
      amount: 30500.97,
      amount_data: {
        value: 30500.97,
        currency: 'USD',
      },
      inv_amount_customer_currency: {
        value: 30500.97,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 30500.97,
            currency: 'USD',
            transformed_currency: 'USD',
          },
        ],
      },
      amount_base_currency: 30500.97,
      inv_balance_due_amount_customer_currency: {
        value: 30500.97,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 30500.97,
            currency: 'USD',
            transformed_currency: 'USD',
          },
        ],
      },
      promise_to_pay_amount: 0,
      promise_to_pay_amount_base_currency: 0,
      due_date: '2024-05-17',
      status_updated_date: '2024-05-17T00:00:00+0000',
      payment_status: 'PENDING',
      followup_status: 'CONTACT_MISSING',
      invoice_date: '2024-04-02',
      customer_id: 1,
      customer_name: 'Peace Inc',
      created_by: {
        id: 1,
        hash: 'W3lhn4FkF45Kxo',
        email: 'vignesh.iyappan@growfin.ai',
        first_name: 'vignesh.iyappan',
        last_name: 'Iyappan',
      },
      created_date: '2024-05-16T05:47:21+0000',
      predicted_pay_date: '2022-04-05',
      billing_contacts: [],
      custom_fields: [],
      draft_invoice: false,
    },
    {
      id: 7,
      currency: 'USD',
      status: 'PENDING',
      deleted: false,
      invoice_no: 'I0007',
      invoice_title: 'I0007',
      balance_due_amount: 40476.63,
      balance_due_amount_data: {
        value: 40476.63,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 40476.63,
            currency: 'USD',
            value_in_transformed_currency: 40476.63,
            transformed_currency: 'USD',
          },
        ],
      },
      balance_due_amount_base_currency: 40476.63,
      amount: 40476.63,
      amount_data: {
        value: 40476.63,
        currency: 'USD',
      },
      inv_amount_customer_currency: {
        value: 40476.63,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 40476.63,
            currency: 'USD',
            transformed_currency: 'USD',
          },
        ],
      },
      amount_base_currency: 40476.63,
      inv_balance_due_amount_customer_currency: {
        value: 40476.63,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 40476.63,
            currency: 'USD',
            transformed_currency: 'USD',
          },
        ],
      },
      promise_to_pay_amount: 0,
      promise_to_pay_amount_base_currency: 0,
      due_date: '2024-05-30',
      status_updated_date: '2024-05-30T00:00:00+0000',
      payment_status: 'PENDING',
      followup_status: 'EMAIL_SENT',
      invoice_date: '2024-04-15',
      customer_id: 1,
      customer_name: 'Peace Inc',
      created_by: {
        id: 1,
        hash: 'W3lhn4FkF45Kxo',
        email: 'vignesh.iyappan@growfin.ai',
        first_name: 'vignesh.iyappan',
        last_name: 'Iyappan',
      },
      created_date: '2024-05-16T05:47:21+0000',
      predicted_pay_date: '2022-04-05',
      billing_contacts: [],
      custom_fields: [],
      draft_invoice: false,
    },
    {
      id: 9,
      currency: 'USD',
      status: 'PARTIAL_PAYMENT',
      deleted: false,
      invoice_no: 'I0009',
      invoice_title: 'I0009',
      balance_due_amount: 29851.99,
      balance_due_amount_data: {
        value: 29851.99,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 29851.99,
            currency: 'USD',
            value_in_transformed_currency: 29851.99,
            transformed_currency: 'USD',
          },
        ],
      },
      balance_due_amount_base_currency: 29851.99,
      amount: 49851.99,
      amount_data: {
        value: 49851.99,
        currency: 'USD',
      },
      inv_amount_customer_currency: {
        value: 49851.99,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 49851.99,
            currency: 'USD',
            transformed_currency: 'USD',
          },
        ],
      },
      amount_base_currency: 49851.99,
      inv_balance_due_amount_customer_currency: {
        value: 29851.99,
        currency: 'USD',
        multi_currency_split: [
          {
            value: 29851.99,
            currency: 'USD',
            transformed_currency: 'USD',
          },
        ],
      },
      promise_to_pay_amount: 0,
      promise_to_pay_amount_base_currency: 0,
      due_date: '2024-06-04',
      status_updated_date: '2024-06-04T00:00:00+0000',
      payment_status: 'PARTIAL',
      followup_status: 'DISPUTE_OPEN',
      invoice_date: '2024-04-20',
      customer_id: 1,
      customer_name: 'Peace Inc',
      created_by: {
        id: 1,
        hash: 'W3lhn4FkF45Kxo',
        email: 'vignesh.iyappan@growfin.ai',
        first_name: 'vignesh.iyappan',
        last_name: 'Iyappan',
      },
      created_date: '2024-05-16T05:47:21+0000',
      predicted_pay_date: '2022-04-05',
      billing_contacts: [],
      custom_fields: [],
      draft_invoice: false,
    },
  ],
  total_records: 60,
  current_page: 1,
  total_pages: 1,
};
